import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetCategories = (params) => {
  return api.get(apiUrl.categories, { params });
};
